/** @format */

import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './app';
import {AccountContextProvider, UserContext} from 'frontier-utilities';
import Global from '../global/container';

// Components for all pages
Global();

// DS styles
import '@/components/sttark_design_system/index.scss';

const el = document.getElementById('root');
const root = createRoot(el);
const userId = el.dataset['userId'];
const isNet30 = parseInt(el.dataset['isNet-30']);
// Entrypoint that binds everything to the DOM
// Don't put anything else in here
root.render(
    <AccountContextProvider>
        <UserContext.Provider
            value={{
                current_user_id: parseInt(userId),
                is_net_30: Boolean(isNet30)
            }}>
            <App />
        </UserContext.Provider>
    </AccountContextProvider>
);
